export const obtemUrlSignin = () => {

    const https = window.location.href

    return https.substring(0, https.indexOf('/', https.indexOf('://') + 3))
}